"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgPwdChangeSelfCtl = /** @class */ (function (_super) {
    __extends(DlgPwdChangeSelfCtl, _super);
    function DlgPwdChangeSelfCtl() {
        return _super.call(this, true) || this;
    }
    DlgPwdChangeSelfCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            newPass: "",
            oldPass: "",
            repeatNewPass: "",
            visible: false
        };
    };
    DlgPwdChangeSelfCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgPwdChangeSelfCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgPwdChangeSelfCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgPwdChangeSelfCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgPwdChangeSelfCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    return DlgPwdChangeSelfCtl;
}(BaseController_1.BaseController));
exports.DlgPwdChangeSelfCtl = DlgPwdChangeSelfCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgPwdChangeSelfCtl.ts
// module id = 886
// module chunks = 0